// import logo from './logo.svg';
import './App.css';
import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import NestedNavBar from './pages/ColumbiaNav';
import { Route, Routes } from 'react-router-dom';
import ColumbiaTabContent from './pages/ColumbiaLocTab';
import CornellTabContent from './pages/CornellLocTab';
import MethodistTabContent from './pages/MethodistLocTab';
import Applications from './pages/Applications';
import LocAnswers from './AnswersList';
import LocAnswersColumbia from './pages/ColumbiaAnswersList';
import LocAnswers160 from './pages/160Answers';
import LocAnswers166 from './pages/166Answers';
import AllenTabContent from './pages/AllenLocTab';
import LocAnswersAllen from './pages/AllenAnswersList';
import LocAnswersCrescent from './pages/CrescentAnswersList';
import LocAnswersAriLot from './pages/469WAnswersList';
import LocAnswersAnnex from './pages/AnnexAnswersList';
import LocAnswersColeman from './pages/ColemanAnswersList';
import LocAnswersCornell from './pages/CornellAnswersList';
import LocAnswersDHK from './pages/DHKAnswersList';
import LocAnswersGreenberg from './pages/GreenbergAnswersList';
import LocAnswersHelmsley from './pages/HelmsleyAnswersList';
import LocAnswersPayson from './pages/PaysonAnswersList';
import LocAnswersCCH from './pages/CCHAnswersList';
import LocAnswersMethodist from './pages/MethodistAnswersList';
import LocAnswersSixSt from './pages/SixStAnswersList';
import LocAnswersDoctors from './pages/Doctors';
import GeneralRules from './pages/Policies';
import MainTable from './pages/TopInfo';
import LocAnswersSpruce from './pages/SpruceAnswersList';
import SpruceTabContent from './pages/SpruceLocTab';
import RateStructure from './pages/RateCalculator';
import CalcUI from './pages/ParkingCost';
import AltParkingTabContent from './pages/AltParkingTab';
import ColumbiaBasicRateTable from './pages/ColumbiaRateTable';
import CornellBasicRateTable from './pages/CornellRateTable';
import MethodistBasicRateTable from './pages/MethodistlRateTable';
import MainTabContent from './pages/HomeCards';
import BasicTable from './pages/MainRateTable';
import LowerManhattanBasicTable from './pages/LowerManhattanRateTable';
import AllenBasicRateTable from './pages/AllenRateTable';
import RatesnavBar from './pages/NestedNav';
import ProrateForm from './pages/MonthlyProrateForm';
import styles from './css/app.module.css';
import { Link } from 'react-router-dom';

function App() {
  return (
    <div style={{ marginTop: '10px' }}>
      <div className={styles.imageRow}>
        {/* <CreateCarousel /> */}
        <div className={styles.imageContainer}>
          <Link to="/ColumbiaLocTab">
            <img
              src={require('./pages/South Property Front.jpg')}
              alt="South Property Garage"
            />
            <div className={styles.caption}>South Property Garage</div>
          </Link>
        </div>
        <Link to="/CornellLocTab">
          <div className={styles.imageContainer}>
            <img src={require('./pages/DHK.jpg')} alt="DHK Garage" />
            <div className={styles.caption}>David H. Koch Garage</div>
          </div>
        </Link>

        <Link to="/SpruceLocTab">
          <div className={styles.imageContainer}>
            <img
              src={require('./pages/8 Spruce.jpg')}
              alt="8 Sprue Street Garage"
            />
            <div className={styles.caption}>8 Spruce Street</div>
          </div>
        </Link>

        <Link to="/CornellLocTab">
          <div className={styles.imageContainer}>
            <img src={require('./pages/Coleman.jpg')} alt="Coleman Garage" />
            <div className={styles.caption}>Coleman Building Garage</div>
          </div>
        </Link>

        <Link to="/MethodistLocTab">
          <div className={styles.imageContainer}>
            <img src={require('./pages/CCH.jpg')} alt="CCH Garage" />
            <div className={styles.caption}>CCH Garage - BMH</div>
          </div>
        </Link>

        <Link to="/CornellLocTab">
          <div className={styles.imageContainer}>
            <img
              src={require('./pages/Greenberg.jpg')}
              alt="Greenberg Garage"
            />
            <div className={styles.caption}>Greenberg Hospital Garage</div>
          </div>
        </Link>
      </div>

      <div
        style={{ marginTop: '25px', marginLeft: '20px' }}
        className="flex-container"
      >
        <NestedNavBar />
      </div>
      <Routes>
        <Route path="/" element={<MainTabContent />}></Route>
        <Route path="ColumbiaLocTab" element={<ColumbiaTabContent />}></Route>
        <Route path="AllenLocTab" element={<AllenTabContent />}></Route>
        <Route path="CornellLocTab" element={<CornellTabContent />}></Route>
        <Route path="MethodistLocTab" element={<MethodistTabContent />}></Route>
        <Route path="SpruceLocTab" element={<SpruceTabContent />}></Route>
        <Route path="applications" element={<Applications />}></Route>
        <Route path="AnswersList" element={<LocAnswers />}></Route>
        <Route path="160Answers" element={<LocAnswers160 />}></Route>
        <Route path="166Answers" element={<LocAnswers166 />}></Route>
        <Route path="Doctors" element={<LocAnswersDoctors />}></Route>
        <Route path="AllenAnswersList" element={<LocAnswersAllen />}></Route>
        <Route
          path="ColumbiaAnswersList"
          element={<LocAnswersColumbia />}
        ></Route>
        <Route
          path="CrescentAnswersList"
          element={<LocAnswersCrescent />}
        ></Route>
        <Route path="469WAnswersList" element={<LocAnswersAriLot />}></Route>
        <Route path="AnnexAnswersList" element={<LocAnswersAnnex />}></Route>
        <Route
          path="ColemanAnswersList"
          element={<LocAnswersColeman />}
        ></Route>
        <Route
          path="CornellAnswersList"
          element={<LocAnswersCornell />}
        ></Route>
        <Route path="DHKAnswersList" element={<LocAnswersDHK />}></Route>
        <Route
          path="GreenbergAnswersList"
          element={<LocAnswersGreenberg />}
        ></Route>
        <Route
          path="HelmsleyAnswersList"
          element={<LocAnswersHelmsley />}
        ></Route>
        <Route path="PaysonAnswersList" element={<LocAnswersPayson />}></Route>
        <Route
          path="MethodistAnswersList"
          element={<LocAnswersMethodist />}
        ></Route>
        <Route path="CCHAnswersList" element={<LocAnswersCCH />}></Route>
        <Route path="SixStAnswersList" element={<LocAnswersSixSt />}></Route>
        <Route path="SpruceAnswersList" element={<LocAnswersSpruce />}></Route>
        <Route path="RateCalculator" element={<RateStructure />}></Route>
        <Route path="ParkingCost" element={<CalcUI />}></Route>
        <Route path="AltParkingTab" element={<AltParkingTabContent />}></Route>
        <Route path="TopInfo" element={<MainTable />}></Route>
        <Route path="Policies" element={<GeneralRules />}></Route>
        <Route path="NestedNav" element={<RatesnavBar />}>
          <Route index element={<BasicTable />} />
          <Route
            path="ColumbiaRateTable"
            element={<ColumbiaBasicRateTable />}
          ></Route>
          <Route
            path="CornellRateTable"
            element={<CornellBasicRateTable />}
          ></Route>
          <Route
            path="MethodistRateTable"
            element={<MethodistBasicRateTable />}
          ></Route>
          <Route
            path="LowerManhattanRateTable"
            element={<LowerManhattanBasicTable />}
          ></Route>
          <Route
            path="AllenRateTable"
            element={<AllenBasicRateTable />}
          ></Route>
          <Route path="ParkingCost" element={<CalcUI />}></Route>
          <Route path="MonthlyProrateForm" element={<ProrateForm />}></Route>
        </Route>
        <Route path="MonthlyProrateForm" element={<ProrateForm />}></Route>
        <Route path="*" element={<MainTabContent />}></Route>
      </Routes>
    </div>
    // </BrowserRouter>
  );
}

export default App;
